module.exports = __webpack_public_path__ + "img/e-seal.d4c6858f.png";